function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Back-Arrow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.1098953,3.67817268 C17.8846544,4.45293171 17.8928066,5.70091205 17.1281039,6.46561479 L6.718,16.875 L36.0161054,16.8751144 C37.1117801,16.8751144 38,17.7633342 38,18.859009 C38,19.9546837 37.1117801,20.8429035 36.0161054,20.8429035 L6.581,20.842 L17.2919806,31.5525937 C18.0357492,32.2963624 18.0730131,33.4762518 17.3982441,34.246013 L17.3101891,34.3400358 C16.5454863,35.1047386 15.297506,35.0965863 14.522747,34.3218273 L0.494493843,20.2935742 C-0.280265184,19.5188152 -0.288417417,18.2708348 0.476285322,17.5061321 L14.3224532,3.65996416 C15.087156,2.89526142 16.3351363,2.90341366 17.1098953,3.67817268 Z",
  id: "Combined-Shape",
  fill: "#1373E6",
  fillRule: "nonzero"
}));

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "18px",
    viewBox: "0 0 32 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Back-Arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/Back-Arrow.f64eaa06.svg";
export { ForwardRef as ReactComponent };